module.exports = __webpack_public_path__ + "img/icon_wy05.18f66c6f.png";